'use strict';

var loadMiraklOffers = require('./loadMiraklOffers');
/**
 * Updates the buybox and load offers when a variant is changed
 * @param {Object} response - The response from the ajax call(Product-Variant)
 */

// display mirakl details
function displayMiraklDetails() {
    // replace mathis buybox with mirakl buybox
    var atbTextWithBundles = $('.product-tile-bundles').attr('addtocart-text-bundle');
    $('.js-add-to-cart-btn').text(atbTextWithBundles);
    if ($('.pdp-buybox .offer-details').length) {
        var offerBuyBox = $('.pdp-buybox .offer-details').detach();
        $( '.pdp-qty-cart-container').html(offerBuyBox);
        $('.offer-quantity-select').attr('lastSelectedQty', offerBuyBox.find('.offer-quantity-select').val());
    } else if ($('.pdp-buybox .qty-cart-container').length) {
        var productBuyBox = $('.pdp-buybox .qty-cart-container').detach();
        $( '.pdp-qty-cart-container').html(productBuyBox);
        $('.offer-quantity-select').attr('lastSelectedQty', productBuyBox.find('.offer-quantity-select').val());
    }

    // move online badge and threshold after variation section
    if ($('.pdp-buybox .badge-threshold-wrap').length) {
        var badgeThresholdContent = $('.pdp-buybox .badge-threshold-wrap').detach();
        $('#online-threshold-container').html(badgeThresholdContent);
    }

    // move pdp seller section before what we offer
    if ($('.pdp-buybox .pdp-seller-details').length) {
        var sellerDetailsContent = $('.pdp-buybox .pdp-seller-details').detach();
        $('#sellerdetailscontent').html(sellerDetailsContent);
    } else if ($('#sellerdetailscontent').length) {
        $('#sellerdetailscontent').empty();
    }

    // move mirakl lead time to ship inside delivery options
    if ($('.pdp-buybox .mirakl-leadtime-to-ship').length) {
        var leadTimeToShip = $('.pdp-buybox .mirakl-leadtime-to-ship').detach();
        $('#mirakl-leadtimetoship-text').html(leadTimeToShip);
    }

    // Enable free shipping for mirakl under delivery option
    if ($('.prices-add-to-cart-actions .offer-add-to-cart').length) {
        var postalCode = $('.delivery-option .btn-postal-code').text().trim();
        if (postalCode !== "null") {
            $('.update-zip-code').addClass('d-none');
        } else {
            $('.update-zip-code').removeClass('d-none');
        }
        $('input[id="home"]').prop('disabled', false);
        $('.delivery-block-js').removeClass('d-none');
    } else {
        $('.update-zip-code').addClass('d-none');
        $('input[id="home"]').prop('disabled', true);
        $('.delivery-block-js').addClass('d-none');
    }
}

function updateBuyBox(response) {
    if (response.data && response.data.isMiraklEnabled) {
        if (response.data.callP11) {
            $('.pdp-buybox').empty().html(response.data.buyboxHtml);
            loadMiraklOffers.loadMiraklOffers();
            displayMiraklDetails();
            updateMiraklAvailabilityMessage();
            // Update promotion tooltip
            $('body').trigger('tooltip:init');
        } else {
            $('.mirakl-offer-list').addClass('d-none');
            $('.mirakl-offer-list').empty();
        }
    }
}

function updateMiraklAvailabilityMessage() {
    if ($('.mirakl-product-availability').length) {
        $('.mirakl-product-availability .availability-msg li').empty();
    }
    if ($('.mirakl-availability-container').length) {
        var outOfStockMsg = $('.mirakl-availability-container').detach();
        $('.mirakl-product-availability .availability-msg li').html(outOfStockMsg);
    }
}

/**
 * Update attributes when the variant was changed + updateBuyBox function call
 */
function updateAttribute() {
    var isMiraklProduct = $('.js-mirakl-offers-json');

    if (isMiraklProduct.length !== 0) {
        displayMiraklDetails();
        updateMiraklAvailabilityMessage();
    }

    $('body').on('product:afterAttributeSelect', function (e, response) {
        if ($('.product-set-detail').eq(0)) {
            updateBuyBox(response);
        }
    });
}

/**
 * mobile show/hide seller info in view more offers list
*/
function viewSellerInfo() {
    $(document).on('click', '.view-seller-info', function () {
        var $arrows = $(this).find('button');
        var sellerInfo = $(this).closest('.seller-info').find('.seller-info-content');
        sellerInfo.slideToggle(function(){
            $arrows.toggle();
        });
    });
}

/**
 * Show Shipping And Return Policy Modal
*/
function showShippingAndReturnPolicyModal() {
    $(document).on('click', '.seller-shipping-return-policy', function (e) {
        var url = $(this).data('url');
        $.ajax({
            url: url,
            type: 'get',
            success: function (data) {
                $('.shippingAndReturnPolicyModal').empty();
                $('.shippingAndReturnPolicyModal').html(data);
                $('#shippingAndReturnPolicyModal').modal('show');
            }
        });
    });
}

module.exports = {
    updateAttribute: updateAttribute,
    viewSellerInfo: viewSellerInfo,
    showShippingAndReturnPolicyModal: showShippingAndReturnPolicyModal
};
